import { render, staticRenderFns } from "./report_shell.vue?vue&type=template&id=06e6d21d&scoped=true&"
import script from "./report_shell.vue?vue&type=script&lang=js&"
export * from "./report_shell.vue?vue&type=script&lang=js&"
import style0 from "./report_shell.vue?vue&type=style&index=0&id=06e6d21d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e6d21d",
  null
  
)

export default component.exports